module.exports = __webpack_public_path__ + "img/DestinyItemManager - Copy.5ec27d53.jpg";